import { api } from "./api";
import type { McpServer } from "./mcp";
import type { SkillDef } from "./skill";

export interface AgentInfo {
  id: string;
  org_id: string;
  created_by: string;
  name: string;
  adapter_type: string;
  model: string;
  system_prompt: string | null;
  working_directory: string;
  tool_permissions: Record<string, unknown>;
  context_window: number;
  visibility_policy: string;
  created_at: string;
  updated_at: string;
}

export const agentService = {
  list: (orgId: string) => api.get<AgentInfo[]>(`/orgs/${orgId}/agents`),
  get: (id: string) => api.get<AgentInfo>(`/agents/${id}`),
  create: (orgId: string, data: Partial<AgentInfo>) =>
    api.post<AgentInfo>(`/orgs/${orgId}/agents`, data),
  update: (id: string, data: Partial<AgentInfo>) =>
    api.put<AgentInfo>(`/agents/${id}`, data),
  delete: (id: string) => api.delete(`/agents/${id}`),

  // Agent MCP bindings
  listAgentMcps: (agentId: string) =>
    api.get<McpServer[]>(`/agents/${agentId}/mcps`),
  bindMcp: (agentId: string, mcpId: string) =>
    api.post(`/agents/${agentId}/mcps/bind`, { mcp_id: mcpId }),
  unbindMcp: (agentId: string, mcpId: string) =>
    api.delete(`/agents/${agentId}/mcps/unbind/${mcpId}`),

  // Agent Skill bindings
  listAgentSkills: (agentId: string) =>
    api.get<SkillDef[]>(`/agents/${agentId}/skills`),
  bindSkill: (agentId: string, skillId: string) =>
    api.post(`/agents/${agentId}/skills/bind`, { skill_id: skillId }),
  unbindSkill: (agentId: string, skillId: string) =>
    api.delete(`/agents/${agentId}/skills/unbind/${skillId}`),
};
